module.exports = __webpack_public_path__ + "img/digital.fc0fe4e3.png";